<template>
    <div>
        <loading-custom :loading="loading" />

        <checkout-sidebar-component
            :salepage="salepage"
            :menus="menus"
            :base_url="base_url"
        />

        <div class="checkout-container tw-mt-12">
            <div class="checkout-item checkout-content">
                <div class="checkout-content__item tw-text-black">
                    <h3 class="tw-text-black text-center">
                        ยืนยันคำสั่งซื้อสินค้า
                    </h3>

                    <div class="card tw-rounded-none mb-3">
                        <div
                            class="card-header tw-bg-white tw-border-none pb-0"
                        >
                            <span class="tw-font-normal tw-text-lg"
                                >ที่อยู่จัดส่ง</span
                            >
                        </div>
                        <div class="card-body">
                            <div class="form-group row mb-1 mx-1">
                                <div
                                    class="col-md-1 pr-0 tw-flex tw-items-center"
                                >
                                    <label class="tw-font-normal m-0 required"
                                        >ชื่อ</label
                                    >
                                </div>
                                <div class="col-md-11">
                                    <input
                                        v-model="name"
                                        name="name"
                                        type="text"
                                        class="form-control input-sm checkout-input-placeholder"
                                        placeholder="ชื่อและนามสกุล"
                                    />
                                </div>
                            </div>
                            <div class="form-group row mb-1 mx-1">
                                <div
                                    class="col-md-1 pr-0 tw-flex tw-items-center"
                                >
                                    <label
                                        class="tw-font-normal m-0 required tw-whitespace-nowrap"
                                        >เบอร์โทร</label
                                    >
                                </div>
                                <div class="col-md-11">
                                    <input
                                        v-model="phone_number"
                                        name="tel"
                                        type="tel"
                                        class="form-control input-sm checkout-input-placeholder"
                                        placeholder="เบอร์โทร"
                                    />
                                </div>
                            </div>
                            <div class="form-group row mb-1 mx-1">
                                <div
                                    class="col-md-1 pr-0 tw-flex tw-items-center"
                                >
                                    <label class="tw-font-normal m-0 required"
                                        >อีเมล</label
                                    >
                                </div>
                                <div class="col-md-11">
                                    <input
                                        v-model="email"
                                        name="email"
                                        type="email"
                                        class="form-control input-sm checkout-input-placeholder"
                                        placeholder="อีเมล"
                                    />
                                </div>
                            </div>
                            <div class="form-group row mb-1 mx-1">
                                <div
                                    class="col-md-1 pr-0 tw-flex tw-items-center"
                                >
                                    <label class="tw-font-normal m-0 required"
                                        >ที่อยู่</label
                                    >
                                </div>
                                <div class="col-md-11">
                                    <textarea
                                        v-model="address"
                                        name="address"
                                        class="form-control checkout-input-placeholder"
                                        placeholder="บ้านเลขที่, อาคาร, ห้อง, ตำบล/แขวง, อำเภอ/เขต จังหวัด รหัสไปรษณีย์ ฯลฯ"
                                    >
                                    </textarea>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card tw-rounded-none mb-3">
                        <div
                            class="card-header tw-bg-white tw-border-none pb-0"
                        >
                            <span class="tw-font-normal tw-text-lg"
                                >วิธีการจัดส่ง</span
                            ><span
                                class="tw-text-xs tw-text-red-400 ml-3"
                                v-if="!transport_id"
                                >กรุณาเลือกวิธีการจัดส่ง</span
                            >
                        </div>
                        <div class="card-body">
                            <div class="form-check row">
                                <div
                                    class="tw-flex tw-justify-between mx-3"
                                    v-for="(item, index) in transports"
                                    :key="index"
                                >
                                    <div class="col-md-6">
                                        <input
                                            v-model="transport_id"
                                            class="form-check-input"
                                            type="radio"
                                            id="transport"
                                            :value="item.id"
                                            name="transport"
                                        />
                                        <label
                                            class="form-check-label tw-font-normal"
                                            for="transport"
                                        >
                                            {{ item.name }}
                                        </label>
                                        <p>
                                            <span class="tw-text-gray-400">{{
                                                item.description
                                            }}</span>
                                            <span
                                                class="tw-text-gray-400"
                                                v-if="
                                                    item.sale_page_transport
                                                        .condition_free_status
                                                "
                                            >
                                                จัดส่งฟรีเมื่อซื้อครบ
                                                {{
                                                    item.sale_page_transport
                                                        .more_price_free
                                                }}
                                                {{
                                                    salepage.shop.currency
                                                        .name || ""
                                                }}
                                            </span>
                                        </p>
                                    </div>
                                    <div
                                        class="col-md-6 tw-flex tw-flex-row-reverse tw-font-normal"
                                    >
                                        <p>
                                            {{
                                                Number(
                                                    item.sale_page_transport
                                                        .price
                                                ).toLocaleString(undefined, {
                                                    minimumFractionDigits: 2
                                                })
                                            }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card tw-rounded-none mb-3">
                        <div
                            class="card-header tw-bg-white tw-border-none pb-0"
                        >
                            <span class="tw-font-normal tw-text-lg wrap"
                                >สรุปรายการ</span
                            >
                        </div>
                        <div class="card-body">
                            <table class="table tw-table-fixed">
                                <thead>
                                    <tr>
                                        <th scope="col" width="17.5%">
                                            สินค้า
                                        </th>
                                        <th scope="col" width="35%"></th>
                                        <th
                                            class="text-right"
                                            scope="col"
                                            width="27.5%"
                                        >
                                            ราคาต่อหน่วย
                                        </th>
                                        <th
                                            class="text-right"
                                            scope="col"
                                            width="20%"
                                        >
                                            จำนวน
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="(item, index) in queue"
                                        :key="index"
                                    >
                                        <td
                                            class="tw-text-xs tw-flex tw-justify-center"
                                        >
                                            <img
                                                :src="
                                                    `${item.product_data.image_url}`
                                                "
                                                class="cart-product__image tw-self-center tw-w-full"
                                            />
                                        </td>
                                        <td
                                            class="tw-text-xs align-middle wrap"
                                        >
                                            {{ item.product_data.name }}
                                        </td>
                                        <td class="text-right align-middle">
                                            {{
                                                salepage.shop.currency.symbol ||
                                                    ""
                                            }}
                                            {{
                                                Number(
                                                    item.product_data.price
                                                ).toLocaleString(undefined, {
                                                    minimumFractionDigits: 2
                                                })
                                            }}
                                        </td>
                                        <td class="text-right align-middle">
                                            {{ item.quantity }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="card tw-rounded-none mb-3">
                        <div
                            class="card-header tw-bg-white tw-border-none pb-0"
                        >
                            <span class="tw-font-normal tw-text-lg"
                                >สรุปยอดสั่งซื้อ</span
                            >
                        </div>
                        <div class="card-body">
                            <div class="form-check row">
                                <div class="tw-flex tw-justify-between mx-3">
                                    <div class="col-md-6 p-0">
                                        <p class="mb-2 tw-font-normal">
                                            ยอดรวมสินค้า
                                        </p>
                                    </div>
                                    <div
                                        class="col-md-6 tw-flex tw-flex-row-reverse"
                                    >
                                        <p class="mb-2 tw-font-normal">
                                            {{
                                                salepage.shop.currency.symbol ||
                                                    ""
                                            }}
                                            {{
                                                Number(
                                                    products_cost
                                                ).toLocaleString(undefined, {
                                                    minimumFractionDigits: 2
                                                })
                                            }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="form-check row">
                                <div class="tw-flex tw-justify-between mx-3">
                                    <div class="col-md-6 p-0">
                                        <p class="mb-2 tw-font-normal">
                                            ค่าจัดส่ง
                                        </p>
                                    </div>
                                    <div
                                        class="col-md-6 tw-flex tw-flex-row-reverse"
                                    >
                                        <p
                                            class="mb-2 tw-font-normal"
                                            v-if="transport_id"
                                        >
                                            {{
                                                salepage.shop.currency.symbol ||
                                                    ""
                                            }}
                                            {{
                                                Number(
                                                    transport_price
                                                ).toLocaleString(undefined, {
                                                    minimumFractionDigits: 2
                                                })
                                            }}
                                        </p>
                                        <p
                                            class="mb-2 tw-font-normal"
                                            v-else-if="!transport_id"
                                        >
                                            <i
                                                class="fa fa-exclamation tw-text-red-400"
                                            ></i>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <hr class="my-1" />
                            <div class="form-check row">
                                <div class="tw-flex tw-justify-between mx-3">
                                    <div class="col-md-6 p-0">
                                        <p class="mb-2 tw-font-normal">
                                            ยอดราคารวม
                                        </p>
                                    </div>
                                    <div
                                        class="col-md-6 tw-flex tw-flex-row-reverse"
                                    >
                                        <p
                                            class="mb-2 tw-font-normal"
                                            v-if="transport_id"
                                        >
                                            {{
                                                salepage.shop.currency.symbol ||
                                                    ""
                                            }}
                                            {{
                                                Number(
                                                    total_cost
                                                ).toLocaleString(undefined, {
                                                    minimumFractionDigits: 2
                                                })
                                            }}
                                        </p>
                                        <p
                                            class="mb-2 tw-font-normal"
                                            v-else-if="!transport_id"
                                        >
                                            <i
                                                class="fa fa-exclamation tw-text-red-400"
                                            ></i>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card tw-rounded-none mb-3">
                        <div
                            class="card-header tw-bg-white tw-border-none pb-0"
                        >
                            <span class="tw-font-normal tw-text-lg"
                                >การชำระเงิน</span
                            >
                        </div>
                        <div class="card-body">
                            <label
                                class="tw-font-normal m-0 required tw-whitespace-nowrap"
                                >เลือกช่องทางการชำระเงิน</label
                            >
                            <div class="tw-grid tw-grid-cols-1 tw-gap-3">
                                <select
                                    id="payment"
                                    name="payment"
                                    v-model="payment_id"
                                    class="form-control tw-border tw-rounded tw-py-1 tw-px-2 tw-text-sm"
                                >
                                    <option value="" disabled
                                        >กรุณาเลือกช่องทางการชำระเงิน</option
                                    >
                                    <option
                                        v-for="(item, index) in payments"
                                        :key="index"
                                        :value="item.id"
                                        >{{ item.account_name }}</option
                                    >
                                </select>
                                <div
                                    v-for="(item, index) in payments"
                                    :key="index"
                                >
                                    <div
                                        v-if="item.id == payment_id"
                                        class="card-body card-bank-account"
                                    >
                                        <div
                                            v-if="item.account_name == 'PayPal'"
                                            id="paypal-button-container"
                                        ></div>
                                        <div
                                            v-else
                                            class="card-bank-account__list tw-grid tw-tw-grid-cols-7 sm:tw-grid-cols-4 tw-gap-2 p-2"
                                        >
                                            <div
                                                class="tw-justify-center tw-cols-span-3 sm:tw-cols-span-1"
                                                v-if="item.media.length > 0"
                                            >
                                                <img
                                                    :src="
                                                        `${api_url}/ajax/frontend/s/${salepage.shop.reference}/payment/${item.id}/image`
                                                    "
                                                    :alt="
                                                        `QR code for ${item.account_name} payment`
                                                    "
                                                    class="tw-w-full"
                                                />
                                                <a
                                                    :href="
                                                        `${api_url}/ajax/frontend/s/${salepage.shop.reference}/payment/${item.id}/image-download`
                                                    "
                                                    class="btn btn-outline-secondary tw-w-full mt-2"
                                                >
                                                    QR Code Download
                                                </a>
                                            </div>
                                            <div
                                                class="tw-cols-span-4 sm:tw-ml-4 sm:tw-col-span-3 tw-self-center"
                                            >
                                                <div
                                                    class="tw-flex tw-items-center tw-text-2xl"
                                                >
                                                    <div
                                                        class="tw-flex tw-items-center"
                                                    >
                                                        <i
                                                            :class="
                                                                `mr-3 bank bank-logo bank-${item.banks.bank_code}`
                                                            "
                                                        ></i>
                                                    </div>
                                                    <div>
                                                        <h6
                                                            class="card-title tw-font-normal card-bank-account-title m-0"
                                                        >
                                                            {{
                                                                item.account_name
                                                            }}
                                                        </h6>
                                                    </div>
                                                </div>
                                                <div
                                                    class="tw-flex tw-items-center mt-4"
                                                >
                                                    <div class="mr-2">
                                                        <p
                                                            class="account-code-text card-text tw-font-normal tw-whitespace-nowrap"
                                                        >
                                                            เลขบัญชี
                                                        </p>
                                                    </div>
                                                    <div>
                                                        <p
                                                            class="account-code-text card-text tw-whitespace-nowrap"
                                                        >
                                                            {{
                                                                item.account_code
                                                            }}
                                                            <i
                                                                class="fa fa-clipboard ml-2"
                                                                v-clipboard:copy="
                                                                    item.account_code
                                                                "
                                                                v-clipboard:success="
                                                                    onCopy
                                                                "
                                                                v-clipboard:error="
                                                                    onError
                                                                "
                                                            >
                                                            </i>
                                                        </p>
                                                    </div>
                                                </div>
                                                <div
                                                    class="tw-flex tw-items-center"
                                                >
                                                    <div class="mr-2">
                                                        <p
                                                            class="account-code-text card-text tw-font-normal tw-whitespace-nowrap"
                                                        >
                                                            ชื่อบัญชี
                                                        </p>
                                                    </div>
                                                    <div>
                                                        <p
                                                            class="card-text account-code-text tw-whitespace-nowrap"
                                                        >
                                                            {{
                                                                item.holder_name
                                                            }}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                class="form-group row mb-0 mt-3"
                                v-if="!isPayPalSelected && payment_id"
                            >
                                <label class="mx-3"
                                    >แนบหลักฐานการชำระเงิน</label
                                >
                                <div class="input-group ml-3 sm:tw-mr-3">
                                    <input
                                        type="file"
                                        id="filePhoto"
                                        class="form-control tw-rounded-none"
                                        @change="onFileChange"
                                    />
                                    <div class="input-group-append"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tw-grid tw-grid-cols-2 tw-gap-2">
                        <a
                            :href="`${salepage.domain_url ? '/' : api_url + '/' + salepage.slug}`"
                        >
                            <button
                                class="btn btn-sm btn-salepage-outline tw-w-full"
                                :style="styleObject"
                            >
                                ย้อนกลับ
                            </button>
                        </a>
                        <button
                            class="btn btn-sm btn-salepage"
                            :disabled="isPayPalSelected"
                            :style="styleObject"
                            @click="store"
                        >
                            ยืนยัน
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
th {
    font-weight: 400;
}
.btn-salepage {
    background: var(--button-color);
    color: var(--text-color);
}
.btn-salepage:disabled {
    background: #d1d5db;
    color: #ffffff;
}

.btn-salepage:hover {
    box-shadow: inset 0px 0px 0px 2000px rgba(0, 0, 0, 0.25);
    transition: all ease 0.1s;
}

.btn-salepage-outline {
    border: 1px solid var(--button-color);
    color: var(--button-color);
    background: transparent;
}

.btn-salepage-outline:hover {
    background: var(--button-color);
    color: var(--text-color);
    transition: all ease 0.1s;
}

.image-product-cart {
    width: 50%;
}
.table tbody tr td {
    white-space: normal;
}
.table tbody th td {
    vertical-align: top;
}
.cart-product__image {
    max-height: 60px;
    max-width: 60px;
    img {
        @media (min-width: 0px) and (max-width: 992px) {
            width: 100%;
            height: auto;
            max-height: 60px;
            max-width: 60px;
            object-fit: contain;
            max-width: -webkit-fill-available;
        }
        height: 100%;
        max-width: -webkit-fill-available;
    }
}
.fa-clipboard {
    cursor: pointer;
}
.card-bank-account {
    border: 1px solid;
    border-radius: 5px;
    padding: 10px;
}

.wrap {
    overflow-wrap: anywhere;
}
</style>

<script>
import { loadScript } from "@paypal/paypal-js";

export default {
    props: ["salepage", "base_url", "menus"],
    data() {
        return {
            api_url: this.base_url,
            products: [],
            payments: [],
            transports: [],
            salePageProducts: [],
            queue: [],
            allProductOrder: {
                product_id: "",
                quantity: "",
                product_data: {}
            },

            name: "",
            phone_number: "",
            email: "",
            address: "",
            transport_id: "",
            payment_id: "",
            transport_price: null,
            sum_product_cost: null,
            total_price: null,

            imageSrc: "",
            image: null,
            imageDir: "/orders",

            copiedText: "",
            loading: false
        };
    },
    created() {
        this.getSaleaPageProduct();
        this.products = JSON.parse(this.getCookies(this.salepage.slug));
    },
    watch: {
        transport_id(val) {
            let selectedTransport = this.transports.find(i => {
                return i.id == val;
            });
            if (
                selectedTransport.sale_page_transport.condition_free_status &&
                this.products_cost >
                    parseInt(
                        selectedTransport.sale_page_transport.more_price_free
                    )
            ) {
                this.transport_price = 0;
            } else {
                this.transport_price =
                    selectedTransport.sale_page_transport.price;
            }
        },
        payment_id(val) {
            let selectedPayment = this.payments.find(i => {
                return i.id == val;
            });

            if (selectedPayment.account_name == "PayPal") {
                this.paypalButton(selectedPayment);
            }
        }
    },
    computed: {
        products_cost() {
            let totalProcuctCost = 0;
            for (let index = 0; index < this.queue.length; index++) {
                totalProcuctCost =
                    totalProcuctCost +
                    this.queue[index]["quantity"] *
                        this.queue[index]["product_data"].price;
            }
            this.sum_product_cost = totalProcuctCost;
            return totalProcuctCost;
        },
        total_cost() {
            let totalCost =
                parseInt(this.sum_product_cost) +
                parseInt(this.transport_price);
            this.total_price = totalCost;

            return totalCost;
        },
        styleObject: function() {
            return {
                "--button-color": this.salepage.button_color || "#000000",
                "--text-color": this.salepage.button_text || "#ffffff"
            };
        },
        isPayPalSelected: function() {
            let selectedPayment = this.payments.find(i => {
                return i.id == this.payment_id;
            });

            if (selectedPayment) {
                return selectedPayment.account_name == "PayPal";
            }

            return false;
        },
        isInfoFilled: function() {
            return (
                this.name &&
                this.phone_number &&
                this.email &&
                this.address &&
                this.transport_id &&
                this.payment_id
            );
        },
    },
    mounted() {
        this.payments = this.salepage.payments;
        this.transports = this.salepage.transports;
    },
    methods: {
        messageAlert(type, title, text) {
            this.$swal({
                icon: type,
                title: title,
                text: text,
                showConfirmButton: true
            });
        },
        getCookies(cname) {
            let name = cname + "=";
            let decodedCookie = decodeURIComponent(document.cookie);
            let ca = decodedCookie.split(";");
            for (let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) == " ") {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        },
        getSaleaPageProduct() {
            const url = `${this.api_url}/ajax/frontend/s/${this.salepage.shop.reference}/salepage/${this.salepage.id}/product`;
            axios.get(url).then(res => {
                this.salePageProducts = res.data.product;

                this.products.forEach(element => {
                    let productId = element.product_id;
                    let salepageProductData = this.salePageProducts.find(i => {
                        return i.id == productId;
                    });

                    if (salepageProductData) {
                        this.allProductOrder.product_data = salepageProductData;
                        this.allProductOrder.product_id = productId;
                        this.allProductOrder.quantity = element.quantity;

                        this.queue.push({ ...this.allProductOrder });
                    }
                });
                this.setTransportid();
            });
        },
        onCopy: function(e) {
            this.copiedText = e.text;
        },
        onError: function(e) {
            console.log("Failed to copy texts");
        },
        uploadImage() {
            document.getElementById("filePhoto").click();
        },
        onFileChange(e) {
            this.loading = true;
            let files = e.target.files || e.dataTransfer.files;
            if (!files.length) {
                this.loading = false;
                return;
            }
            const file_size = files[0].size / 1024 / 1024;
            const file_name = files[0].name;
            const re = /(\.jpg|\.jpeg|\.png)$/i;
            if (file_size > 2) {
                this.messageAlert(
                    "error",
                    "ขนาดภาพใหญ่ไปนะ",
                    "TwT ขอโทษนะ กรุณาใช้ภาพขนาดไม่เกิน 2mb"
                );
                this.loading = false;
            } else if (!re.exec(file_name)) {
                this.messageAlert(
                    "error",
                    "ไฟล์นี้ใช้ไม่ได้นะ",
                    "TwT ขอโทษนะ กรุณาใช้รูปภาพประเภท jpg, jpeg, png"
                );
                this.loading = false;
            } else {
                this.image = files[0];
                this.loading = false;
            }
        },
        checkDomain() {
            let url;
            if (
                `${window.location.protocol}//${window.location.hostname}` ==
                this.api_url
            ) {
                url = `${this.api_url}/${this.salepage.slug}`;
            } else {
                url = `${window.location.protocol}//${window.location.hostname}/${this.salepage.slug}`;
            }
            return url;
        },
        setTransportid() {
            if (this.transports.length > 0) {
                this.transport_id = this.transports[0].id;
            }
        },

        async paypalButton(selectedPayment) {
            try {
                let totalCost = this.total_cost;
                let store = this.store;

                if (!this.isInfoFilled) {
                    this.messageAlert(
                        "error",
                        "ข้อมูลของคุณไม่ครบ",
                        "กรุณาใส่ข้อมูลให้ครบถ้วน"
                    );
                    this.payment_id = "";

                    return;
                }
                const paypal = await loadScript({
                    "client-id": selectedPayment.client_id,
                    currency: this.salepage.shop.currency.code
                });

                await paypal
                    .Buttons({
                        createOrder: function(data, actions) {
                            return actions.order.create({
                                purchase_units: [
                                    {
                                        amount: {
                                            value: totalCost
                                        }
                                    }
                                ]
                            });
                        },
                        onApprove: function(data, actions) {
                            return actions.order
                                .capture()
                                .then(function(orderData) {
                                    console.log(orderData);
                                    store(orderData);
                                    // Successful capture!
                                    // e.g. Inertia.post(route('order.update', reference.orderId)
                                });
                        },
                        style: {
                            layout: "horizontal",
                            color: "gold",
                            shape: "rect",
                            label: "paypal"
                        }
                    })
                    .render("#paypal-button-container");
            } catch (error) {
                console.log(error);
            }
        },
        getTransportName(id) {
            let transport = this.transports.find(element => element.id == id);

            return transport ? transport.name : "";
        },
        getPaymentName(id) {
            let payment = this.payments.find(element => element.id == id);
            
            return payment ? payment.account_name + " - " + payment.account_code + ' (' + payment.holder_name + ')' : "";
        },
        store(orderData = "") {
            let orderProducts = this.queue.map(detail => {
                let data = {
                    ...{ product_id: detail.product_id },
                    ...{ quantity: detail.quantity }
                };
                return data;
            });

            // let config = {
            //   headers: {
            //     'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
            //   }
            // }

            if (!this.name && !this.phone_number && !this.address) {
                this.messageAlert(
                    "error",
                    "กรุณาใส่ข้อมูลให้ครบถ้วน",
                    "ชื่อและนามสกุล, เบอร์โทรศัพท์, ที่อยู่"
                );
            } else if (!this.transport_id) {
                this.messageAlert("error", "กรุณาเลือกวิธีการจัดส่ง", "");
                this.loading = false;
            } else if (!this.image && !this.isPayPalSelected) {
                this.messageAlert(
                    "error",
                    "กรุณาอัพโหลดหลักฐานการชำระเงิน",
                    ""
                );
                this.loading = false;
            } else {
                this.$swal({
                    icon: "warning",
                    title: "กรุณาตรวจสอบข้อมูลให้ถูกต้อง",
                    html: `
                        <div class="tw-grid tw-grid-cols-2 tw-gap-x-2 tw-text-sm text-left px-0 lg:px-4">
                            <div><strong>ชื่อ</strong></div> <div>${this.name}</div>
                            <div><strong>เบอร์โทรศัพท์</strong></div> <div>${this.phone_number}</div>
                            <div><strong>ที่อยู่</strong></div> <div>${this.address}</div>
                            <div><strong>วิธีการจัดส่ง</strong></div> <div>${this.getTransportName(this.transport_id)}</div>
                            <div><strong>ช่องทางชำระเงิน</strong></div> <div>${this.getPaymentName(this.payment_id)}</div>
                        </div>
                        <br>
                        <strong>หลักฐานการชำระเงิน</strong><br>
                        <img src=${this.image ? URL.createObjectURL(this.image) : ""} width="200" height="200">
                        `,
                    confirmButtonText: "ยืนยัน",
                    showCancelButton: true,
                    cancelButtonText: "ยกเลิก",
                    reverseButtons: true
                }).then(result => {
                    if (result.isConfirmed) {
                        this.loading = true;
                        let formData = new FormData();

                        if (this.isPayPalSelected) {
                            formData.append("paypalOrderId", orderData.id);
                        } else {
                            formData.append("image", this.image);
                        }
                        formData.append("sale_page_id", this.salepage.id);
                        formData.append("shop_id", this.salepage.shop_id);
                        formData.append("name", this.name);
                        formData.append("phone_number", this.phone_number);
                        formData.append("email", this.email);
                        formData.append("address", this.address);
                        formData.append("transport_id", this.transport_id);
                        formData.append("payment_id", this.payment_id);
                        formData.append(
                            "products",
                            JSON.stringify(orderProducts)
                        );

                        axios
                            .post(`/`, formData, {
                                headers: {
                                    "Content-Type": "multipart/form-data",
                                    "X-CSRF-TOKEN": document.querySelector(
                                        'meta[name="csrf-token"]'
                                    ).content
                                }
                            })
                            .then(res => {
                                if (res.data.status === "success") {
                                    let orderSlug = res.data.orderSlug;

                                    let url = this.checkDomain();
                                    window.location.replace(
                                        `${url}/status-form/${orderSlug}`
                                    );
                                } else {
                                    this.messageAlert(
                                        "error",
                                        "Sorry",
                                        res.data.message
                                    );
                                }
                            })
                            .catch(err => {
                                this.messageAlert(
                                    "error",
                                    "Sorry",
                                    err.response.data.message
                                );
                            })
                            .then(() => {
                                this.loading = false;
                            });
                    }
                });
            }
        }
    }
};
</script>
